
import React from 'react';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import { VideoEvent } from '@/hooks/useVideoEvents';
import VideoCard from './VideoCard';

interface DayGroupProps {
  dateStr: string;
  events: VideoEvent[];
  channelNames: Record<string, string>;
  onVideoClick: (videoId?: string) => void;
}

const DayGroup: React.FC<DayGroupProps> = ({ dateStr, events, channelNames, onVideoClick }) => {
  const date = new Date(dateStr);
  const dayName = format(date, 'EEE', { locale: fr });
  const dayNumber = format(date, 'dd');
  
  return (
    <div className="mb-6">
      <div className="flex items-start mb-2">
        <div className="w-16 mr-4 flex flex-col items-center">
          <span className="calendar-day-name capitalize">{dayName}</span>
          <span className="calendar-day-number text-2xl">{dayNumber}</span>
        </div>
        
        <div className="flex-1 space-y-3">
          {events.map((event, index) => (
            <VideoCard 
              key={`${event.id}-${index}`}
              event={event}
              channelName={channelNames[event.profileId] || "Chargement de la chaîne..."}
              onVideoClick={onVideoClick}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default DayGroup;
